class FootnoteHoverHandler {
  private currentTooltip: HTMLElement | null = null;
  private currentFootnote: HTMLElement | null = null;

  constructor() {
    this.init();
  }

  private getContainer(): HTMLElement | null {
    // Look for lightbox container first (for lightbox-opened articles), then regular item-wrapper
    return (
      (document.querySelector(".lightbox-article") as HTMLElement) ||
      (document.querySelector(".item-wrapper") as HTMLElement)
    );
  }

  private init(): void {
    // Use event delegation on document for all footnote elements

    document.addEventListener("mouseover", (e) => {
      const target = e.target as HTMLElement;
      const footnoteElement = target.closest(".footnote");

      if (
        footnoteElement &&
        footnoteElement.classList.contains("footnote") &&
        !footnoteElement.classList.contains("expanded")
      ) {
        this.showFootnote(footnoteElement as HTMLElement);
      }
    });

    document.addEventListener("mouseout", (e) => {
      const target = e.target as HTMLElement;
      const relatedTarget = e.relatedTarget as HTMLElement;
      const footnoteElement = target.closest(".footnote");

      // Don't hide if moving within the same footnote container (e.g., hovering links)
      if (!relatedTarget) {
        return;
      }

      const leavingFootnote =
        footnoteElement && !footnoteElement.classList.contains("expanded");
      const leavingTooltip =
        footnoteElement && footnoteElement.classList.contains("expanded");

      // Check if we're moving to the tooltip or staying within the footnote area
      if (leavingFootnote) {
        const movingToTooltip = relatedTarget.closest(".footnote.expanded");
        const movingToSameFootnote =
          relatedTarget.closest(".footnote") === this.currentFootnote;
        const stayingInsideFootnote = footnoteElement.contains(relatedTarget);

        if (
          !movingToTooltip &&
          !movingToSameFootnote &&
          !stayingInsideFootnote &&
          footnoteElement === this.currentFootnote
        ) {
          this.hideFootnote();
        }
      }

      // Hide when leaving the tooltip
      if (leavingTooltip && footnoteElement === this.currentTooltip) {
        const movingToOriginal =
          relatedTarget.closest(".footnote") === this.currentFootnote;
        const stayingInsideTooltip = footnoteElement.contains(relatedTarget);

        if (!movingToOriginal && !stayingInsideTooltip) {
          this.hideFootnote();
        }
      }
    });
  }

  private showFootnote(footnoteElement: HTMLElement): void {
    // Don't recreate tooltip if hovering the same footnote
    if (footnoteElement === this.currentFootnote) {
      return;
    }
    const container = this.getContainer();
    if (!container) return;

    // Remove any existing tooltip
    this.hideFootnote();

    // Store reference to current footnote
    this.currentFootnote = footnoteElement;

    // Clone the footnote
    const tooltip = footnoteElement.cloneNode(true) as HTMLElement;
    tooltip.classList.add("expanded");
    tooltip.style.pointerEvents = "auto"; // Allow mouse events on tooltip

    // Position it absolutely over the hovered element
    const rect = footnoteElement.getBoundingClientRect();
    tooltip.style.position = "absolute";
    tooltip.style.left = `${rect.left}px`;
    tooltip.style.top = `${rect.top + container.scrollTop}px`;
    tooltip.style.width = `${rect.width + 20}px`; // Match the width of the original footnote + padding
    tooltip.style.zIndex = "1000";

    // Add to document
    container.appendChild(tooltip);
    this.currentTooltip = tooltip;

    // Ensure tooltip stays within viewport
  }

  private hideFootnote(): void {
    if (this.currentTooltip) {
      this.currentTooltip.remove();
      this.currentTooltip = null;
    }
    this.currentFootnote = null;
  }
}

export default FootnoteHoverHandler;
